import { CBOX_OPTIONS } from '../utilities/constant_config';

let variableValue = {};
const passwPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const namePattern = /^[a-zA-Z0-9-_ ']+$/;
const validDateFormat = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
const validDateEntriesForMonth = {
  '01': '31',
  '02': '28',
  '03': '31',
  '04': '30',
  '05': '31',
  '06': '30',
  '07': '31',
  '08': '31',
  '09': '30',
  '10': '31',
  '11': '30',
  '12': '31'
};

export function checkWidth() {
  const innerWidth = window.innerWidth;
  if (innerWidth >= 992) {
    return CBOX_OPTIONS.maxWidthLg;
  } else if (innerWidth >= 768 && innerWidth < 992) {
    return CBOX_OPTIONS.maxWidthMd;
  } else {
    return CBOX_OPTIONS.maxWidthSm;
  }
}
export function checkHeight() {
  const innerHeight = window.innerHeight;
  if (innerHeight >= 992) {
    return CBOX_OPTIONS.maxHeightLg;
  } else if (innerHeight >= 768 && innerHeight < 992) {
    return CBOX_OPTIONS.maxHeightMd;
  } else {
    return CBOX_OPTIONS.maxHeightSm;
  }
}
export function CheckPassword(target) {
  const passId = $(target).val();
  const pass = passId.match(passwPattern);
  if (pass === null && passId !== '') return false;
  return true;
}

export function validateEmail(target) {
  const emailId = $(target).val();
  const email = emailId.match(emailPattern);
  if (email === null && emailId !== '') return false;
  return true;
}

export function validateDateUtil(ddlMonth, ddlDay, ddlYear) {
  const monthVal = ddlMonth.val();
  const dayVal = ddlDay.val();
  const yearVal = ddlYear.val();
  if (
    (monthVal === '04' ||
      monthVal === '06' ||
      monthVal === '09' ||
      monthVal === '11') &&
    dayVal === '31'
  ) {
    return false;
  }
  if (monthVal === '02') {
    var isleap =
      yearVal % 4 === 0 && (yearVal % 100 !== 0 || yearVal % 400 === 0);
    if (dayVal > '29' || (dayVal === '29' && !isleap)) {
      return false;
    }
  }
}

export function numbersOnly(e) {
  let charCode = e.which ? e.which : e.keyCode;
  if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
    return false;
  else return true;
}

export function formatPhoneNumber(phoneNumberString) {
  var formattedText = phoneNumberString.replace(
    /(\d{3})(\d{3})(\d{4})/,
    '$1.$2.$3'
  );
  return formattedText;
}

export function setvariableValue(key, value) {
  variableValue[key] = value;
}

export function getvariableValue(key) {
  return variableValue[key];
}

export function showPassword(selector) {
  const pwdElement = $(selector);
  const pwdValLength = $(pwdElement).val().length;
  if (pwdValLength) {
    $(pwdElement).attr('type', 'text');
  }
}
export function hidePassword(selector) {
  const pwdElement = $(selector);
  const pwdValLength = $(pwdElement).val().length;
  if (pwdValLength) {
    $(pwdElement).attr('type', 'password');
  }
}

export function checkForNameValidation(e) {
  const nameStatus = e.key.match(namePattern);
  if (nameStatus === null && nameStatus !== '') return false;
  return true;
}

export function truncateText(element, charLength) {
  var totalAlertText = element.text();
  var truncatedText = totalAlertText.substr(0, charLength) + '..';
  return truncatedText;
}

function checkLeapYear(year) {
  return year % 400 == 0 || (year % 100 != 0 && year % 4 == 0);
}

export function validateDateManualEntry(dateEntry) {
  const dateEnteredFormat = dateEntry.match(validDateFormat);
  if (dateEnteredFormat === null && dateEnteredFormat !== '') return false;
  else {
    const dateSelected = dateEntry.split('/');
    if (dateSelected[0].length === 1 || dateSelected[1].length === 1) {
      return false;
    }
    if (
      dateSelected[1] === '29' &&
      dateSelected[0] === '02' &&
      checkLeapYear(dateSelected[2])
    ) {
      return true;
    } else if (
      validDateEntriesForMonth[dateSelected[0]] &&
      dateSelected[1] <= validDateEntriesForMonth[dateSelected[0]]
    ) {
      return true;
    } else {
      return false;
    }
  }
}

export function formatZipCode(e) {
  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
    return false;
  }

  var zipcode = $(this).val();
  zipcode = zipcode.replace(/-/g, ''); // remove all occurrences of '-'

  if (zipcode.length > 5) {
    $(this).val(`${zipcode.substring(0, 5)}-${zipcode.substring(5)}`);
  } else if (zipcode.length == 5) {
    $(this).val(zipcode.substring(0, 5));
  }
}

export function loginNavigatePage() {
  let navigateLoginUrl = null;
  navigateLoginUrl = localStorage.getItem('loginForwardingUrl');
  console.log(navigateLoginUrl);
  localStorage.removeItem('loginForwardingUrl');
  if (navigateLoginUrl != null && navigateLoginUrl != undefined) {
    window.location.replace(
      `${ACC.config.encodedContextPath}${navigateLoginUrl}`
    );
  }
}

export function validateOnlyEmailFormat(emailAddress) {
  const emailValid = emailAddress.length
    ? emailAddress.match(emailPattern)
    : true;
  return emailValid;
}

function selectmenuPlaceholderHandler($el, val, def) {
  if (val === def || (!def && !val)) {
    $el.addClass('has-placeholder');
  } else {
    $el.removeClass('has-placeholder');
  }
}

export function selectmenuChangeHandler(ev, ui) {
  var $select = $(ev.target);

  selectmenuPlaceholderHandler(
    $select.next(),
    $select.val(),
    ($select.data('default') || '') + ''
  );
}

export function initializeSelectMenuCreation(ev, ui) {
  const thisObj = $(this);
  const thisObjVal = thisObj.val();
  const defaultValue = (thisObj.data('default') || '') + '';
  selectmenuPlaceholderHandler(
    $(ev.currentTarget).next(),
    thisObjVal,
    defaultValue
  );
}

export function initializeDatepickers(selector, datepickerOptions = {}) {
  $(selector).datepicker(datepickerOptions);
}

export function restrictInvalidCharacters(e, regex) {
  var s = String.fromCharCode(e.which);
  if (regex.test(s)) return true;
  else return false;
}

export function nextPrevSelectors(selector, options) {
  options.prevSelector = `.bxslider-carousel__${selector}-prev`;
  options.nextSelector = `.bxslider-carousel__${selector}-next`;
  return options;
}

export function disabledArrowsAccessibility(slider) {
  const carouselArrows = $(slider)
    .parents('.bx-wrapper')
    .siblings('.bxslider-carousel__product-icon');
  carouselArrows
    .find('a')
    .not('.disabled')
    .attr('href', '');
  carouselArrows.find('a.disabled').removeAttr('href');
}

export function zipCodeValidator(e, input) {
  let regexp = /(^\d{5}$)|(^\d{5,9}$)/;
  let copiedText = input.val();
  let finalVal;
  if (regexp.test(copiedText)) {
    if (copiedText.length > 5 && copiedText.length <= 9) {
      input.val(
        ''
          .concat(copiedText.substring(0, 5), '-')
          .concat(copiedText.substring(5))
      );
      finalVal = input.val();
    } else {
      finalVal = input.val();
    }
  } else {
    finalVal = input.val();
  }
  let regex = new RegExp('^[0-9]{5}(?:-[0-9]{1,4})?$');
  if (!regex.test(finalVal)) {
    return true;
  }
  return false;
}

export function iosSelectmenuAccessibilityFixes(selectField) {
  let selectPanalId =
    '#' + selectField.next('.ui-selectmenu-button').attr('aria-owns');
  let focussedELement;
  if (
    $(document)
      .find(`${selectPanalId} .ui-state-active`)
      .parent()
      .hasClass('ui-state-disabled')
  ) {
    focussedELement = $(document)
      .find(`${selectPanalId} .ui-state-active`)
      .parent()
      .next('.ui-menu-item')
      .find('.ui-menu-item-wrapper');
  } else {
    focussedELement = $(document).find(`${selectPanalId} .ui-state-active`);
  }
  if (window.innerWidth <= 767) {
    focussedELement.attr('tabindex', 0);

    setTimeout(function() {
      focussedELement.focus();
    }, 200);
  } else {
    focussedELement.removeAttr('tabindex');
  }
}

export function validateEnteredDate(dateText){
  let validateDateManualEntryReturnVal = validateDateManualEntry(dateText);
  if(validateDateManualEntryReturnVal){
	  let currentDate = new Date();
    let userDate = new Date(dateText);
    let yearMaxLimit = currentDate.getFullYear();
	  let yearMinLimit = yearMaxLimit - 120;
	  const yearSelected = dateText.split('/')[2];
    if(currentDate.getTime() <= userDate.getTime()){
		  validateDateManualEntryReturnVal = false;
	  }else if(yearSelected != undefined && (yearSelected < yearMinLimit || yearSelected > yearMaxLimit)){
	    validateDateManualEntryReturnVal = false;
	  }  
  }
  return validateDateManualEntryReturnVal;
}
